import React from "react";
import { Route, Routes } from "react-router-dom";

// Import your components
import AdminLayout from "./Layout/AdminLayout.jsx";
import Dashboard from "./Pages/Dashboard.jsx";
import LoginPage from "./Pages/Login.js";
import UserList from "./Pages/UserList.js";
import CreatePlan from "./Pages/CreatePlan.js";
import PlanList from "./Pages/PlanList.js";
import RegisterPage from "./Pages/Register.js";
import GetProfilePage from "./Pages/GetProfilePage.js";
import CreateBanner from "./Pages/CreateBanner.js";
import CreateCampaign from "./Pages/CreateCampaign.js";
import CampaignList from "./Pages/CampaignList.js";
import StepsManagement from "./Pages/StepsManagement.js";
import BannerList from "./Pages/BannerList.js";
import FAQsManagement from "./Pages/FAQsManagement.js";
import PurchasedPlans from "./Pages/PurchasedPlans.js";
import ContactMessages from "./Pages/ContactMessages.js";
import SocialContacts from "./Pages/SocialContacts.js";
import CompanyContacts from "./Pages/CompanyContacts.js";
import TestimonialsManagement from "./Pages/TestimonialsManagement.js";
import CampaignBookings from "./Pages/CampaignBookings.js";
import RedemptionRequests from "./Pages/RedemptionRequests.js";
import CompanyAbout from "./Pages/CompanyAbout.js";
import ManageCategories from "./Pages/ManageCategories.js";
import AdminBonus from "./Pages/AdminBonus.js";
import UserTransactions from "./Pages/UserTransactions.js";
import AdminPlatformCharge from "./Pages/AdminPlatformCharge.js";




function App() {
  return (
    <Routes>
      {/* Login page rendered outside AdminLayout */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* All other routes inside AdminLayout */}
      <Route
        path="/*"
        element={
          <AdminLayout>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/users" element={<UserList />} />
              <Route path="/users/:id/transactions" element={<UserTransactions />} />
              <Route path="/profile" element={<GetProfilePage />} />



              <Route path="/createcampaign" element={<CreateCampaign />} />
              <Route path="/camp" element={<CampaignList />} />
              <Route path="/createbanner" element={<CreateBanner />} />
              <Route path="/steps" element={<StepsManagement />} />
              <Route path="/faqs" element={<FAQsManagement />} />
              <Route path="/userscontacts" element={<ContactMessages />} />
              <Route path="/social" element={<SocialContacts />} />
              <Route path="/companycontacts" element={<CompanyContacts />} />
              <Route path="/aboutus" element={<CompanyAbout />} />
              <Route path="/testimonial" element={<TestimonialsManagement />} />
              <Route path="/bannerlist" element={<BannerList />} />
              <Route path="/purchasedplans" element={<PurchasedPlans />} />
              <Route path="/campbookings" element={<CampaignBookings />} />
              <Route path="/create-plan" element={<CreatePlan />} />
              <Route path="/planlist" element={<PlanList />} />
              <Route path="/withdrawal-requests" element={<RedemptionRequests />} />
              <Route path="/categories" element={<ManageCategories />} />
              <Route path="/admin-bonus" element={<AdminBonus />} />
              <Route path="/platform-charge" element={<AdminPlatformCharge />} />










            </Routes>
          </AdminLayout>
        }
      />
      <Route path="/register" element={<RegisterPage />} />
    </Routes>
  );
}

export default App;
